import React from 'react';
import { Alert } from '@cloudscape-design/components';
import { Question } from 'src/types/helios/Question';
import { translationNeedsReview } from 'src/helper/translationHelper';

interface TranslationStalenessAlertProps {
  question: Question;
  selectedLanguage: string;
}

/**
 * Displays a warning alert when a translation is stale (created for an older question version).
 * Conditionally shows the version comparison only when validFromQuestionVersion is available.
 * Renders nothing if the translation is current or doesn't exist.
 */
const TranslationStalenessAlert: React.FC<TranslationStalenessAlertProps> = ({
  question,
  selectedLanguage,
}) => {
  if (!translationNeedsReview(question, selectedLanguage)) {
    return null;
  }

  const version =
    question.localeTranslationContentMap?.[selectedLanguage]?.validFromQuestionVersion;
  const showVersionComparison = version && Number(version) < Number(question.version);

  return (
    <Alert type="warning" header="Translation Review Required">
      The default language content has been updated since this translation was last
      reviewed
      {showVersionComparison && (
        <>
          {' '}
          (Question version: {version} → {question.version})
        </>
      )}
      . Please review and update the translation to ensure it reflects the latest changes.
    </Alert>
  );
};

export default TranslationStalenessAlert;
